/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class DisclaimersClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getUserDisclaimer: (
			application?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/disclaimers?';
            if (application === null) {
                throw new Error('The parameter "application" cannot be null.');
            } else if (application !== undefined) {
                clientRequestUrl += 'application=' + encodeURIComponent('' + application) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        validateUserDisclaimer: (
        ): string => {
            let clientRequestUrl = '/api/v1/disclaimers';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getLastValidatedContent: (
        ): string => {
            let clientRequestUrl = '/api/v1/disclaimers/last-validated-content';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        generateContent: (
        ): string => {
            let clientRequestUrl = '/api/v1/disclaimers/do-generate-content';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all disclaimer information related to the specified application and the connected user.
     * @param application (optional) The application key for which disclaimers are retrieved.
     * @return OK
     */
    getUserDisclaimer(application?: string | undefined): Promise<GetUserDisclaimerResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getUserDisclaimer(
            application,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetUserDisclaimerResponse>(_response, false, []);
        });
    }

    /**
     * Validates the disclaimer for the connected user and the specified application.
     * @param body (optional) The request containing the application information.
     * @return No Content
     */
    validateUserDisclaimer(body?: ValidateUserDisclaimerRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.validateUserDisclaimer(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Retrieves the last validated disclaimer content for the connected user.
     * @return OK
     */
    getLastValidatedContent(): Promise<GetUserDisclaimerContentResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getLastValidatedContent(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetUserDisclaimerContentResponse>(_response, false, []);
        });
    }

    /**
     * Generates disclaimer content for the connected user based on the specified language and application.
     * @param body (optional) The request containing the language and application information.
     * @return OK
     */
    generateContent(body?: GenerateContentRequest | undefined): Promise<GetUserDisclaimerContentResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.generateContent(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetUserDisclaimerContentResponse>(_response, false, []);
        });
    }
}

export class TermsOfUsesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        accept: (
        ): string => {
            let clientRequestUrl = '/api/v1/terms-of-uses/accept';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        generateDocument: (
        ): string => {
            let clientRequestUrl = '/api/v1/terms-of-uses/generate-document';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Mark the terms of use request as validated
     * @param body (optional) ID of the ToU request to be validated
     * @return No Content
     */
    accept(body?: AcceptTermsOfUseRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.accept(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Get the Terms of use document to be display on the frontend.
     * @return OK
     */
    generateDocument(): Promise<TermsOfUseDocumentResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.generateDocument(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<TermsOfUseDocumentResponse>(_response, false, []);
        });
    }
}

export interface AcceptTermsOfUseRequest {
    requestId: string;
}

export interface ErrorDto {
    code?: string | undefined;
    message?: string | undefined;
    target?: string | undefined;
    details?: ErrorDto[] | undefined;
}

export interface DetailedError extends ErrorDto {
    detailedMessage?: string | undefined;
    stackTrace?: string | undefined;
}

export interface GenerateContentRequest {
    language: string;
    application: string;
}

export interface GetUserDisclaimerContentResponse {
    html?: string | undefined;
}

export interface GetUserDisclaimerResponse {
    needsDisclaimerValidation: boolean;
    hasRestrictiveCountry: boolean;
}

export interface TermsOfUseDocumentResponse {
    content?: string | undefined;
}

export interface ValidateUserDisclaimerRequest {
    application: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

export class Utilities
{
    public static async processResponse<T>(
        response: Response,
        isFile: boolean,
        dateFields: string[],
    ): Promise<T> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status >= 200 && status < 300) {
            if (isFile) {
                const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
                const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
                return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers } as unknown as T; });
            }
            if (response && response.text) {
                return response.text().then((_responseText) => {
                    try {
                        const result: any = _responseText === '' ? null : JSON.parse(_responseText, (key, value) => {
                            if (value
                                && dateFields?.includes(key)
                                && (typeof value === 'string' || (Array.isArray(value) && value.every(i => typeof i === 'string'))) 
                                ) {
                               if (Array.isArray(value)) {
                                    return value.map(v => Utilities.ConvertToDate(v));
                                }
                                else {
                                    return Utilities.ConvertToDate(value);
                                }
                            }
                            return value;
                        }) as T;
                        return result;
                    } catch (error) {
                        return Promise.reject(new SwaggerException(error instanceof Error ? error.message : 'JSON.parse error', status, _responseText, _headers, null));
                    }
                });
            }
            else {
                return Promise.resolve<T>(<any>null);
            }
        }

        const errorMessage = status < 500 ? 'A server error occurred.' : 'An unexpected server error occurred.';

        if (response instanceof Error) {
        	return Promise.reject(new SwaggerException(response.message, status, response.message, _headers, null));
        }

        if (response && response.text) {
        	const responseText = await response.text();
        	return Promise.reject(new SwaggerException(errorMessage, status, responseText, _headers, null));
        }

        return Promise.resolve<T>(<any>null);
    }

    public static ConvertToDate (value: any) {
        const date = new Date(value);
        return isNaN(date.getTime()) ? value : date;
    }
}